export enum AutocompletePlacesTypes {
  CITIES = '(cities)',
  CITIES_AND_ROUTES = 'geocode',
  CITIES_ONLY= 'cities_only'
}
